import React, { Suspense } from 'react';

// Fallback CSS-only spinner (no depende de ninguna libreria externa)
const SimpleSpinner = ({ message = 'Cargando...', size = 60 }) => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="flex flex-col items-center">
      <div
        style={{
          width: size,
          height: size,
          border: '4px solid #e8e8e8',
          borderTopColor: '#0047bb',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      />
      <p className="mt-3 text-gray-600">{message}</p>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  </div>
);

// ErrorBoundary local para capturar si Lottie falla
class LottieErrorBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error) {
    console.warn('Lottie Loading falló, usando spinner simple:', error?.message);
  }
  render() {
    if (this.state.hasError) return <SimpleSpinner message={this.props.message} size={this.props.size} />;
    return this.props.children;
  }
}

// Lazy-load del Player para que si la libreria lottie falla al cargar, no crashee la app
const LottiePlayer = React.lazy(() =>
  import('@lottiefiles/react-lottie-player')
    .then(mod => ({ default: mod.Player }))
    .catch(() => ({ default: () => null })) // si falla el import, renderiza null
);

const SoccerLoader = ({
  message = 'Cargando...',
  size = 180,
  speed = 0.5,
}) => {
  let soccerAnimation;
  try {
    // Import sincrono del JSON; si falla, cae al fallback
    soccerAnimation = require('../../../assets/soccerloading.json');
  } catch (err) {
    console.warn('No se pudo cargar la animacion de loading, usando spinner simple');
    return <SimpleSpinner message={message} size={Math.min(size, 80)} />;
  }

  return (
    <LottieErrorBoundary message={message} size={Math.min(size, 80)}>
      <Suspense fallback={<SimpleSpinner message={message} size={Math.min(size, 80)} />}>
        <div className="min-h-screen flex items-center justify-center">
          <div className="flex flex-col items-center">
            <LottiePlayer
              src={soccerAnimation}
              autoplay
              loop
              speed={speed}
              style={{ width: size, height: size }}
              className="drop-shadow-md"
            />
            <p className="mt-3 text-gray-600">{message}</p>
          </div>
        </div>
      </Suspense>
    </LottieErrorBoundary>
  );
};

export default SoccerLoader;
